// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout Styles */

/* Admin Layout */
.admin-layout {
  display: flex;
  min-height: 100vh;
  background-color: var(--background-light);
}

.admin-sidebar {
  width: 256px;
  background-color: var(--surface-light);
  border-right: 1px solid var(--slate-200);
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  overflow-y: auto;
  z-index: 100;
  display: flex;
  flex-direction: column;
}

.sidebar-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1.5rem;
}

.sidebar-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  margin-bottom: 1.5rem;
}

.profile-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary) 0%, #816bf5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: var(--shadow-md);
}

.profile-avatar .material-symbols-outlined {
  font-size: 28px;
}

.profile-info h1 {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--text-main);
  margin: 0;
}

.profile-info p {
  font-size: 0.75rem;
  color: var(--text-sub);
  margin: 0;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 0.75rem;
  border-radius: 0.5rem;
  color: var(--text-sub);
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  transition: all var(--transition-fast);
  cursor: pointer;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  font-family: var(--font-family);
}

.nav-item:hover {
  background-color: var(--slate-50);
  color: var(--text-main);
}

.nav-item:hover .material-symbols-outlined {
  color: var(--primary);
}

.nav-item.active {
  background-color: var(--primary-light);
  color: var(--primary);
  font-weight: 600;
}

.nav-item.active .material-symbols-outlined {
  color: var(--primary);
}

.nav-item .material-symbols-outlined {
  font-size: 24px;
  color: var(--slate-400);
  transition: color var(--transition-fast);
}

.sidebar-footer {
  margin-top: auto;
  padding-top: 1rem;
  border-top: 1px solid var(--slate-200);
}

.logout-btn {
  color: var(--text-sub);
}

.logout-btn:hover {
  color: #dc2626;
  background-color: #fef2f2;
}

.logout-btn .material-symbols-outlined {
  color: var(--slate-400);
}

.logout-btn:hover .material-symbols-outlined {
  color: #dc2626;
}

.admin-main {
  flex: 1 1;
  margin-left: 256px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.admin-header {
  height: 64px;
  background-color: var(--surface-light);
  border-bottom: 1px solid var(--slate-200);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
  position: sticky;
  top: 0;
  z-index: 50;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  color: var(--text-sub);
}

.breadcrumb .material-symbols-outlined {
  font-size: 18px;
  margin: 0 0.25rem;
}

.breadcrumb .current {
  color: var(--text-main);
  font-weight: 500;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.home-btn {
  min-width: 84px;
  height: 40px;
  padding: 0 1.5rem;
  border-radius: 0.5rem;
  font-weight: 700;
  letter-spacing: 0.015em;
  color: white;
  background-color: var(--primary);
  transition: all var(--transition-fast);
  text-decoration: none;
}

.home-btn:hover {
  background-color: var(--primary);
  color: white;
  box-shadow: var(--shadow-md);
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  color: var(--text-sub);
}

.mobile-menu-btn .material-symbols-outlined {
  font-size: 24px;
}

.admin-content {
  flex: 1 1;
  padding: 1.5rem 2rem;
  overflow-y: auto;
  background-color: var(--background-light);
}

/* Mobile Overlay */
.mobile-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 90;
}

/* Public Layout */
.public-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--background-light);
}

.public-header {
  position: sticky;
  top: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 2.5rem;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--slate-200);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo {
  width: 32px;
  height: 32px;
  color: var(--primary);
}

.logo .material-symbols-outlined {
  font-size: 32px;
}

.public-header h2 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-main);
  margin: 0;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.header-nav {
  display: flex;
  gap: 2.25rem;
}

.header-nav a {
  color: var(--text-sub);
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  transition: color var(--transition-fast);
}

.header-nav a:hover,
.header-nav a.active {
  color: var(--primary);
}

.login-btn {
  min-width: 84px;
  height: 40px;
  padding: 0 1.5rem;
  border-radius: 0.5rem;
  font-weight: 700;
  letter-spacing: 0.015em;
  color: white;
  background-color: var(--primary);
  transition: all var(--transition-fast);
}

.login-btn:hover {
  background-color: var(--primary);
  color: white;
  box-shadow: var(--shadow-md);
}

.public-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.public-footer {
  width: 100%;
  padding: 1.5rem;
  text-align: center;
  color: var(--text-sub);
  font-size: 0.875rem;
  border-top: 1px solid var(--slate-200);
  background-color: var(--surface-light);
}

/* Responsive */
@media (max-width: 768px) {
  .admin-sidebar {
    transform: translateX(-100%);
    transition: transform var(--transition-slow);
  }

  .admin-sidebar.mobile-open {
    transform: translateX(0);
  }

  .admin-main {
    margin-left: 0;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .mobile-overlay.active {
    display: block;
  }

  .public-header {
    padding: 0.75rem 1rem;
  }

  .header-nav {
    display: none;
  }

  .admin-content {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Layout.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB,iBAAiB;AACjB;EACE,aAAa;EACb,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,wCAAwC;EACxC,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oEAAoE;EACpE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,0CAA0C;EAC1C,2BAA2B;EAC3B,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE;IACE,4BAA4B;IAC5B,4CAA4C;EAC9C;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Layout Styles */\n\n/* Admin Layout */\n.admin-layout {\n  display: flex;\n  min-height: 100vh;\n  background-color: var(--background-light);\n}\n\n.admin-sidebar {\n  width: 256px;\n  background-color: var(--surface-light);\n  border-right: 1px solid var(--slate-200);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  overflow-y: auto;\n  z-index: 100;\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebar-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 1.5rem;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.profile-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--primary) 0%, #816bf5 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.profile-avatar .material-symbols-outlined {\n  font-size: 28px;\n}\n\n.profile-info h1 {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: var(--text-main);\n  margin: 0;\n}\n\n.profile-info p {\n  font-size: 0.75rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n.sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  flex: 1;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.625rem 0.75rem;\n  border-radius: 0.5rem;\n  color: var(--text-sub);\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-decoration: none;\n  transition: all var(--transition-fast);\n  cursor: pointer;\n  background: none;\n  border: none;\n  width: 100%;\n  text-align: left;\n  font-family: var(--font-family);\n}\n\n.nav-item:hover {\n  background-color: var(--slate-50);\n  color: var(--text-main);\n}\n\n.nav-item:hover .material-symbols-outlined {\n  color: var(--primary);\n}\n\n.nav-item.active {\n  background-color: var(--primary-light);\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.nav-item.active .material-symbols-outlined {\n  color: var(--primary);\n}\n\n.nav-item .material-symbols-outlined {\n  font-size: 24px;\n  color: var(--slate-400);\n  transition: color var(--transition-fast);\n}\n\n.sidebar-footer {\n  margin-top: auto;\n  padding-top: 1rem;\n  border-top: 1px solid var(--slate-200);\n}\n\n.logout-btn {\n  color: var(--text-sub);\n}\n\n.logout-btn:hover {\n  color: #dc2626;\n  background-color: #fef2f2;\n}\n\n.logout-btn .material-symbols-outlined {\n  color: var(--slate-400);\n}\n\n.logout-btn:hover .material-symbols-outlined {\n  color: #dc2626;\n}\n\n.admin-main {\n  flex: 1;\n  margin-left: 256px;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.admin-header {\n  height: 64px;\n  background-color: var(--surface-light);\n  border-bottom: 1px solid var(--slate-200);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1.5rem;\n  position: sticky;\n  top: 0;\n  z-index: 50;\n}\n\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.875rem;\n  color: var(--text-sub);\n}\n\n.breadcrumb .material-symbols-outlined {\n  font-size: 18px;\n  margin: 0 0.25rem;\n}\n\n.breadcrumb .current {\n  color: var(--text-main);\n  font-weight: 500;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.home-btn {\n  min-width: 84px;\n  height: 40px;\n  padding: 0 1.5rem;\n  border-radius: 0.5rem;\n  font-weight: 700;\n  letter-spacing: 0.015em;\n  color: white;\n  background-color: var(--primary);\n  transition: all var(--transition-fast);\n  text-decoration: none;\n}\n\n.home-btn:hover {\n  background-color: var(--primary);\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.mobile-menu-btn {\n  display: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  color: var(--text-sub);\n}\n\n.mobile-menu-btn .material-symbols-outlined {\n  font-size: 24px;\n}\n\n.admin-content {\n  flex: 1;\n  padding: 1.5rem 2rem;\n  overflow-y: auto;\n  background-color: var(--background-light);\n}\n\n/* Mobile Overlay */\n.mobile-overlay {\n  display: none;\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 90;\n}\n\n/* Public Layout */\n.public-layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--background-light);\n}\n\n.public-header {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 2.5rem;\n  background-color: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(12px);\n  border-bottom: 1px solid var(--slate-200);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.logo {\n  width: 32px;\n  height: 32px;\n  color: var(--primary);\n}\n\n.logo .material-symbols-outlined {\n  font-size: 32px;\n}\n\n.public-header h2 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-main);\n  margin: 0;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.header-nav {\n  display: flex;\n  gap: 2.25rem;\n}\n\n.header-nav a {\n  color: var(--text-sub);\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.header-nav a:hover,\n.header-nav a.active {\n  color: var(--primary);\n}\n\n.login-btn {\n  min-width: 84px;\n  height: 40px;\n  padding: 0 1.5rem;\n  border-radius: 0.5rem;\n  font-weight: 700;\n  letter-spacing: 0.015em;\n  color: white;\n  background-color: var(--primary);\n  transition: all var(--transition-fast);\n}\n\n.login-btn:hover {\n  background-color: var(--primary);\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.public-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.public-footer {\n  width: 100%;\n  padding: 1.5rem;\n  text-align: center;\n  color: var(--text-sub);\n  font-size: 0.875rem;\n  border-top: 1px solid var(--slate-200);\n  background-color: var(--surface-light);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .admin-sidebar {\n    transform: translateX(-100%);\n    transition: transform var(--transition-slow);\n  }\n\n  .admin-sidebar.mobile-open {\n    transform: translateX(0);\n  }\n\n  .admin-main {\n    margin-left: 0;\n  }\n\n  .mobile-menu-btn {\n    display: flex;\n  }\n\n  .mobile-overlay.active {\n    display: block;\n  }\n\n  .public-header {\n    padding: 0.75rem 1rem;\n  }\n\n  .header-nav {\n    display: none;\n  }\n\n  .admin-content {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
